module.exports = __webpack_public_path__ + "img/logo_liveabc_only_S_size.a23a41a1.png";